import * as go from 'gojs';
import * as uuid from 'uuid';
import { getPointString, getSizeString } from '../../../../../utils/stringify-utils';
import { NodeGroupNodeCreateProps } from '../models/node-group-node-create-props';
import { NodeGroupNode } from '../models/shape-node.model';

export const createNodeGroupNode = (
  diagram: go.Diagram,
  { width, height, categoryName, location }: NodeGroupNodeCreateProps,
) => {
  const key = uuid.v4();

  diagram.commit(() =>
    diagram.model.addNodeData(
      new NodeGroupNode(key, categoryName, getSizeString(width, height), getPointString(location.x, location.y)),
    ),
  );

  const node = diagram.findNodeForKey(key);
  return node;
};
